<div class="page__item">
  <div class="box">
    <router-outlet></router-outlet>
  </div>
</div>
